(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nova-conversion-layer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-nova-conversion]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const dialog = root.querySelector('[data-nova-dialog]');
    const chip = root.querySelector('[data-nova-chip]');
    const title = root.querySelector('[data-nova-title]');
    const copy = root.querySelector('[data-nova-copy]');
    const primary = root.querySelector('[data-nova-primary]');
    const chipCount = root.querySelector('[data-nova-chip-count]');
    const cartTemplate = root.querySelector('[data-nova-cart-template]');
    const designMode = root.dataset.designMode === 'true';
    let count = Number(root.dataset.initialCount || 0);
    let closeTimer;
    let cartAssurance;

    const messageForCount = (itemCount) => {
      if (itemCount >= 3) {
        return {
          title: root.dataset.unlockedTitle,
          copy: root.dataset.unlockedCopy,
          cart: root.dataset.cartUnlocked,
          cta: root.dataset.ctaCart,
          href: root.dataset.cartUrl,
        };
      }
      if (itemCount === 2) {
        return {
          title: root.dataset.twoTitle,
          copy: root.dataset.twoCopy,
          cart: root.dataset.cartTwo,
          cta: root.dataset.ctaProducts,
          href: root.dataset.productsUrl,
        };
      }
      if (itemCount === 1) {
        return {
          title: root.dataset.oneTitle,
          copy: root.dataset.oneCopy,
          cart: root.dataset.cartOne,
          cta: root.dataset.ctaProducts,
          href: root.dataset.productsUrl,
        };
      }
      return {
        title: root.dataset.emptyTitle,
        copy: root.dataset.emptyCopy,
        cart: root.dataset.cartEmpty,
        cta: root.dataset.ctaProducts,
        href: root.dataset.productsUrl,
      };
    };

    const findCartTarget = () => {
      if (document.querySelector('.nv-cart-promo')) return null;
      return (
        document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer') ||
        document.querySelector('.cart-notification__links')
      );
    };

    const mountCartAssurance = () => {
      const target = findCartTarget();
      if (!target || target.querySelector('[data-nova-cart-assurance]')) {
        cartAssurance = target?.querySelector('[data-nova-cart-assurance]') || cartAssurance;
        return;
      }
      const fragment = cartTemplate.content.cloneNode(true);
      target.prepend(fragment);
      cartAssurance = target.querySelector('[data-nova-cart-assurance]');
    };

    const render = () => {
      const state = messageForCount(count);
      title.textContent = state.title;
      copy.textContent = state.copy;
      primary.textContent = state.cta;
      primary.href = state.href;
      chipCount.textContent = count >= 3 ? '✓' : `${count}/3`;
      chip.classList.toggle('is-unlocked', count >= 3);

      root.querySelectorAll('[data-nova-step]').forEach((step) => {
        const stepNumber = Number(step.dataset.novaStep);
        const active = stepNumber === 1 || count >= stepNumber;
        step.classList.toggle('is-active', active);
        step.classList.toggle('is-current', count > 0 && Math.min(count, 3) === stepNumber);
      });

      mountCartAssurance();
      if (cartAssurance) {
        const cartMessage = cartAssurance.querySelector('[data-nova-cart-message]');
        if (cartMessage) cartMessage.textContent = state.cart;
      }
    };

    const closeDialog = () => {
      window.clearTimeout(closeTimer);
      if (dialog.open) dialog.close();
      chip.hidden = false;
    };

    const openDialog = (autoClose = false) => {
      render();
      chip.hidden = true;
      if (!dialog.open) dialog.showModal();
      window.clearTimeout(closeTimer);
      if (autoClose) closeTimer = window.setTimeout(closeDialog, 8500);
    };

    const refreshCart = async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const cart = await response.json();
        count = Number(cart.item_count || 0);
        render();
      } catch {
        render();
      }
    };

    root.querySelectorAll('[data-nova-close]').forEach((button) => {
      button.addEventListener('click', closeDialog);
    });

    chip.addEventListener('click', () => openDialog(false));
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('close', () => {
      chip.hidden = false;
    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        window.setTimeout(refreshCart, 700);
        window.setTimeout(refreshCart, 1400);
      },
      true
    );

    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart:refresh', refreshCart);
    document.addEventListener('shopify:section:load', () => {
      mountCartAssurance();
      render();
    });

    render();
    refreshCart();
    [600, 1600, 3000].forEach((delay) => {
      window.setTimeout(() => {
        mountCartAssurance();
        render();
      }, delay);
    });

    if (designMode) {
      chip.hidden = false;
    } else {
      window.requestAnimationFrame(() => openDialog(true));
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["summer-discount-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-nv-summer-discount]');
    if (!banner) return;

    const closeButton = banner.querySelector('[data-nv-summer-discount-close]');
    const countdown = banner.querySelector('[data-nv-summer-discount-countdown]');
    const cycleAnchor = Date.parse(banner.dataset.nvPromotionCycleAnchor || '');
    const cycleHours = Number.parseFloat(banner.dataset.nvPromotionCycleHours || '48');
    const cycleDurationMilliseconds = cycleHours * 60 * 60 * 1000;
    const impressionKey = 'nv-summer-discount-10-three-items-recurring-v1';
    const maximumImpressions = 2;
    let promotionEndsAt;
    let closeTimer;
    let countdownTimer;

    const getCurrentCycleEnd = (now = Date.now()) => {
      if (!Number.isFinite(cycleAnchor) || !Number.isFinite(cycleDurationMilliseconds) || cycleDurationMilliseconds <= 0) {
        return now + (48 * 60 * 60 * 1000);
      }
      if (now < cycleAnchor) return cycleAnchor;
      const completedCycles = Math.floor((now - cycleAnchor) / cycleDurationMilliseconds);
      return cycleAnchor + ((completedCycles + 1) * cycleDurationMilliseconds);
    };

    const readImpressions = () => {
      try {
        return Number.parseInt(window.sessionStorage.getItem(impressionKey) || '0', 10) || 0;
      } catch (error) {
        return 0;
      }
    };

    const writeImpressions = (value) => {
      try {
        window.sessionStorage.setItem(impressionKey, String(value));
      } catch (error) {
        return;
      }
    };

    const updateCountdown = () => {
      const now = Date.now();
      if (!Number.isFinite(promotionEndsAt) || promotionEndsAt <= now) {
        promotionEndsAt = getCurrentCycleEnd(now);
      }

      const remainingMilliseconds = Math.max(0, promotionEndsAt - now);
      const totalSeconds = Math.floor(remainingMilliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (countdown) {
        countdown.dateTime = new Date(promotionEndsAt).toISOString();
        countdown.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      }
    };

    function closeBanner() {
      window.clearTimeout(closeTimer);
      window.clearInterval(countdownTimer);
      banner.classList.remove('is-visible');
      window.setTimeout(() => {
        banner.hidden = true;
      }, 220);
    }

    const showBanner = () => {
      updateCountdown();
      const impressions = readImpressions();
      if (impressions >= maximumImpressions) return;
      writeImpressions(impressions + 1);
      banner.hidden = false;
      window.requestAnimationFrame(() => {
        banner.classList.add('is-visible');
        countdownTimer = window.setInterval(updateCountdown, 1000);
        closeTimer = window.setTimeout(closeBanner, 10000);
      });
    };

    document.documentElement.classList.remove('nv-summer-promotion-expired');
    promotionEndsAt = getCurrentCycleEnd();
    closeButton?.addEventListener('click', closeBanner);
    updateCountdown();
    if (document.readyState === 'complete') {
      window.setTimeout(showBanner, 200);
    } else {
      window.addEventListener('load', () => window.setTimeout(showBanner, 200), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
